/// <reference path="../../app.definition.ts" />

import angular from "angular";
import { Serializable } from "./Serializable";
import { User } from "./user";
import { Subject } from "./subject";
import { Discussion } from "./discussion";

export class DocumentList implements Serializable<DocumentList> {
    ids: number[];
    documents: Discussion[];

    deserialize(input: any) {
        !!input.ids && (this.ids = input.ids);

        if (!!input.documents) {
            this.documents = [];
            angular.forEach(input.documents, (doc: Discussion) => {
                this.documents.push(new Discussion().deserialize(doc));
            });
        }

        return this;
    }

    constructor() {
    }
}

export class UserList implements Serializable<UserList> {
    ids: number[];
    users: User[];

    deserialize(input: any) {
        !!input.ids && (this.ids = input.ids);

        if (!!input.users) {
            this.users = [];
            angular.forEach(input.users, (doc: User) => {
                this.users.push(new User().deserialize(doc));
            });
        }

        return this;
    }

    constructor() {
    }
}

export class SubjectList implements Serializable<SubjectList> {
    ids: number[];
    subjects: Subject[];

    deserialize(input: any) {
        !!input.ids && (this.ids = input.ids);

        if (!!input.subjects) {
            this.subjects = [];
            angular.forEach(input.subjects, (doc: Subject) => {
                this.subjects.push(new Subject().deserialize(doc));
            });
        }

        return this;
    }

    constructor() {
    }
}
